import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';
import type { Mode, ModeContextType } from './modeTypes';

const ModeContext = createContext<ModeContextType | undefined>(undefined);

export function ModeProvider({ children }: { children: ReactNode }) {
  // Initialize mode from localStorage using lazy initialization
  const [mode, setMode] = useState<Mode>(() => {
    const savedMode = localStorage.getItem('appMode') as Mode | null;
    return savedMode || 'support';
  });

  // Persist mode preference
  useEffect(() => {
    localStorage.setItem('appMode', mode);
  }, [mode]);

  return (
    <ModeContext.Provider value={{ mode, setMode }}>
      {children}
    </ModeContext.Provider>
  );
}

export function useMode() {
  const context = useContext(ModeContext);
  if (!context) throw new Error('useMode must be used within a ModeProvider');
  return context;
}